import RouterView from '@/views/common-view/index.vue';
import list from '@cloudpivot/list/pc';
export default {
    infoPath: {
        path: '/application/:appCode',
        name: 'application',
        component: RouterView,
    },
    infoChildren: [
        {
            path: 'application-list/:schemaCode',
            name: 'applicationList',
            component: list.components.ApplicationList
        },
        {
            path: 'application-define/:url',
            name: 'applicationDefine',
            component: () => import('@/views/applications/application-define.vue'),
        },
        {
            path: 'application-report/:reportCode',
            name: 'applicationReport',
            component: () => import('@/views/applications/report.vue')
        },
        {
            path: 'application-custom',
            name: 'custom',
            component: () => import('@/views/applications/custom-router-page/test.vue')
        }
    ]
};
